import { categories, navLinks } from "@/mocks/platforms";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-shell px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl">瓜圈榜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              独立整理的吃瓜与爆料类平台排行站，用热度、口碑与推荐三种视角，帮你在信息洪流里快速找到对味的阵地。
            </p>
            <a
              href="mailto:hello@guaquanbang.com"
              className="mt-5 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              hello@guaquanbang.com
            </a>
          </div>

          <div>
            <h2 className="font-heading text-base font-semibold text-background-50">站内导航</h2>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-base font-semibold text-background-50">主题分类</h2>
            <ul className="mt-4 space-y-2.5">
              {categories
                .filter((c) => c.id !== "all")
                .map((c) => (
                  <li key={c.id}>
                    <a href="#category" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                      {c.name}榜
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-base font-semibold text-background-50">关于榜单</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>
                <a href="#guide" className="hover:text-background-50 transition-colors cursor-pointer">评选维度说明</a>
              </li>
              <li>
                <a href="#faq" className="hover:text-background-50 transition-colors cursor-pointer">常见问题</a>
              </li>
              <li>
                <a href="#about" className="hover:text-background-50 transition-colors cursor-pointer">品牌与团队</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-background-50 transition-colors cursor-pointer">平台推荐与反馈</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {year} 瓜圈榜 · 榜单内容仅为信息整理与用户参考，不代表对任何平台内容的认可
          </p>
          <p className="text-xs text-background-400">
            本站不接受付费上榜，名次随数据变化
          </p>
        </div>
      </div>
    </footer>
  );
}